// 轻量 HTTP 封装（项目未引入 axios，使用 fetch）
// 当前采用“直连后端”（不走 devServer proxy），避免出现 /api/api 重写等问题。
// 后端入口：ThinkPHP 需要 index.php

// export const API_BASE = 'http://localhost:81/index.php'
// export const API_BASE = 'http://175.178.189.46/public/index.php'
// export const API_BASE = 'https://hrexample.asia/yy/public/index.php'
export const API_BASE = 'https://hxmgl.com/public/index.php'

function buildQuery(params = {}) {
  const sp = new URLSearchParams()
  Object.keys(params).forEach(k => {
    const v = params[k]
    if (v === undefined || v === null || v === '') return
    sp.append(k, v)
  })
  const qs = sp.toString()
  return qs ? `?${qs}` : ''
}

const AUTH_KEY = 'yy_auth'

function getRequestOptions(method = 'GET', body = null) {
  const headers = { 'Content-Type': 'application/json' }

  try {
    const raw = localStorage.getItem(AUTH_KEY)
    const auth = raw ? JSON.parse(raw) : null
    if (auth && auth.token) {
      headers['Authorization'] = `Bearer ${auth.token}`
      // 有些 PHP/服务器不会转发 Authorization header，额外带上 X-Token 以供后端读取
      headers['X-Token'] = auth.token
    }
  } catch (e) {
    // ignore
  }

  const options = {
    method,
    headers
  }

  if (body) {
    options.body = JSON.stringify(body)
  }

  return options
}

export async function apiGet(path, params) {
  const res = await fetch(`${API_BASE}${path}${buildQuery(params)}`, getRequestOptions('GET'))
  return handle(res)
}

export async function apiPost(path, body) {
  const res = await fetch(`${API_BASE}${path}`, getRequestOptions('POST', body || {}))
  return handle(res)
}

export async function apiPut(path, body) {
  try {
    console.log('HTTP PUT', `${API_BASE}${path}`, 'body:', body)
  } catch (e) {
    // ignore logging errors
  }
  const res = await fetch(`${API_BASE}${path}`, getRequestOptions('PUT', body || {}))
  return handle(res)
}

export async function apiDelete(path) {
  const res = await fetch(`${API_BASE}${path}`, getRequestOptions('DELETE'))
  return handle(res)
}

/**
 * 上传文件（FormData），保留认证头但不要设置 Content-Type，使用 fetch 直接发送 FormData
 */
export async function apiUpload(path, formData) {
  const headers = {}
  try {
    const raw = localStorage.getItem(AUTH_KEY)
    const auth = raw ? JSON.parse(raw) : null
    if (auth && auth.token) {
      headers['Authorization'] = `Bearer ${auth.token}`
      headers['X-Token'] = auth.token
    }
  } catch (e) {
    // ignore
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers,
    body: formData
  })
  return handle(res)
}

async function handle(res) {
  const text = await res.text()

  let json
  try {
    json = JSON.parse(text)
  } catch (e) {
    throw new Error(`服务端返回非 JSON（HTTP ${res.status}）：${text.slice(0, 200)}`)
  }

  if (json.code !== 0) {
    const err = new Error(json.message || '请求失败')
    err.code = json.code
    err.data = json.data
    throw err
  }
  return json.data
}
